import { render } from "./whats-on-event.vue?vue&type=template&id=fe37a3d6"
import script from "./whats-on-event.vue?vue&type=script&lang=js"
export * from "./whats-on-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__